<div class="error-wrapper">
  <div class="error">
    <div class="logo__error">
      <img src="./assets/styles/portal/build/assets/images/reflecx-logo.svg" alt="" />
    </div>
    <div class="error__inner">
      <i class="fal fa-exclamation-circle"></i>
      <h1>You are signed out!</h1>
      <p>Users are advised to close the browser window after signing out.</p>
      <p>Il est conseillé aux utilisateurs de fermer la fenêtre du navigateur après s'être déconnectés.</p>
    </div>
  </div>
</div>
